// resources/js/Pages/SceneGeneration/RatingsTable.js
import React from 'react';
import { gradeColors } from './Constants';

/* label-lookup once, reuse everywhere */
export const ratingLabels = {
  rating:'Overall', conceptrating:'Concept', plotrating:'Plot',
  charactersrating:'Characters', emotional_impact:'Emotional Impact',
  conflict_level:'Conflict Level', dialoguerating:'Dialogue',
  storyforward:'Story Forward', characterchanges:'Character Changes',
  highstakes:'High Stakes', internal_goal_score:'Internal Goal',
  external_goal_score:'External Goal', originality_score:'Originality',
  engagement_score:'Engagement', pacing_score:'Pacing',
  formatting_score:'Formatting', structure_score:'Structure'
};

const ratingKeys = Object.keys(ratingLabels);

/**
 * Helper function to format numbers consistently
 */
const formatRating = (value) => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  
  const num = parseFloat(value);
  if (!Number.isFinite(num)) {
    return '—';
  }
  
  // Format to 1 decimal place, then remove trailing .0
  return num.toFixed(1).replace(/\.0$/, '');
};

/**
 * rows: [{ label : string , ratings : {k:number|'-'} }]
 */
export default function RatingsTable({ rows = [] }) {
  if (!rows.length) return null;

  /* best-score per column - for purple badge */
  const bestPerKey = {};
  ratingKeys.forEach(k => {
    bestPerKey[k] = Math.max(
      ...rows.map(r => {
        const num = parseFloat(r.ratings?.[k]);
        return Number.isFinite(num) ? num : -Infinity;
      })
    );
  });

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-sm text-center align-middle">
        <thead className="table-light">
          <tr>
            <th style={{minWidth:120}}>Version</th>
            {ratingKeys.map(k => <th key={k}>{ratingLabels[k]}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <th className="text-start">{r.label}</th>
              {ratingKeys.map(k => {
                const rawValue = r.ratings?.[k];
                const formattedValue = formatRating(rawValue);
                const numValue = parseFloat(rawValue);
                const isValidNumber = Number.isFinite(numValue);
                const bg = isValidNumber ? gradeColors[Math.round(numValue)] : 'transparent';
                const isBest = isValidNumber && numValue === bestPerKey[k];

                return (
                  <td key={k} style={{backgroundColor: bg}}>
                    {isBest ? (
                      <span style={{
                        display:'inline-block',
                        padding:'2px 6px',
                        borderRadius:'50%',
                        border:'2px solid purple',
                        fontWeight:'bold'
                      }}>
                        {formattedValue}
                      </span>
                    ) : (
                      formattedValue
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}